require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-employee-receives-award-from-indiana-latino-expo.json") })
        }
      }, "path---articles-financial-center-employee-receives-award-from-indiana-latino-expo");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-employee-receives-award-from-indiana-latino-expo!./.cache/json/articles-financial-center-employee-receives-award-from-indiana-latino-expo.json
// module id = 1610
// module chunks = 231608221292675